import { LogicContext } from '../types';

export const recalculateSockets = async (
  context: LogicContext,
  event: { data: { size: 'small' | 'medium' | 'wide' } }
) => {
  return {
    shouldUpdateLayout:
      context.currentScreenSize === 'wide' ||
      (['small', 'medium'].includes(context.currentScreenSize) &&
        event.data.size === 'wide'),
    shouldFetchBackground: context.currentScreenSize === 'small',
    ...event.data,
  };
};
